import '@/styles/style.css';

import ui from '@nuxt/ui/vue-plugin';
import { createPinia } from 'pinia';
import type { Plugin } from 'vue';
import { createApp } from 'vue';

import { setupValibotI18n } from '@ohmybible/core';

import App from '@/App.vue';
import { apolloClient } from '@/core/apollo/client';
import { setupLaunchQueue } from '@/core/pwa/launch-queue';
import router from '@/core/router';
import { useTheme } from '@/shared/composables/useTheme';

setupValibotI18n();

// Initialize the color-mode singleton before mount so the resolved theme class
// is applied to <html> as early as possible (the inline script in index.html
// handles the very first paint).
useTheme();

import * as plugins from '@/core/plugins';
import * as ApolloComposable from '@vue/apollo-composable';

import { registerModules } from '@/core/register-modules.ts';

import { AuthModule } from '@/modules/auth';
import { InboxModule } from '@/modules/inbox';
import { OauthModule } from '@/modules/oauth';
import { UsersModule } from '@/modules/users';

registerModules({
  AuthModule,
  InboxModule,
  OauthModule,
  UsersModule,
});

const app = createApp(App);

app.use(createPinia());
app.use(router);
app.use(ui);
app.provide(ApolloComposable.ApolloClients, {
  default: apolloClient,
});

for (const plugin of Object.values(plugins) as Plugin[]) {
  app.use(plugin);
}

router.isReady().then(() => {
  app.mount('#app');
  setupLaunchQueue(router);
});
